export enum TransactionStatus {
    SUCCESS = "Congratulations! Your order is processed, and it will reflect in ",
    PENDING = "Your order is placed successfully. It will be processed subject to the realization of payment.",
    REJECTED = "Sorry, your order is rejected. Any amount debited will be refunded within 3-5 working days.",
    FAILED = "Sorry, your order is not placed.",
}

export enum KYCStatus {
    STARTKYC =  "Complete your KYC and get upto ₹200 cashback and 0.25% offer benefit on 1st transaction.",
    COMPLETE = "Thank you for submitting your KYC. Start investing to earn ₹200 cashback and 0.25% offer benefit on your 1st transaction.",
    SUBMISSION_PENDING = "KYC not submitted. Please submit your KYC to start investing.",
    REINITIATE = "Oops! Your KYC has been rejected, complete your KYC now to earn attractive rewards.",
    DONE = "Thank you for submitting KYC. You will receive a confirmation on email/whatsapp soon."
}

export enum BannerType {
    TRANSACTION = "transaction",
    KYC = "kyc",
}
